import React, { Component } from 'react';
import { Dropdown, Button } from 'antd';
import MediaUploadDialog from '../MediaUploadDialog';
import RenderMediaItem from './RenderMediaItem';
import { LeftOutlined, RightOutlined, DownOutlined, CloudUploadOutlined } from '@ant-design/icons';
import './MediaWrapper.scss';

export default class MediaListDisplay extends Component {
	render() {
		const {
			media,
			mediaPerPage,
			page,
			handlePageChange,
			handleMediaUploadOpen,
			menu,
			client,
			mediaUploadDialogOpen,
			handleMediaUploadOk,
			event,
			refetch,
			listType,
			handlePickItem,
			showHeader,
		} = this.props;

		const header = (
			<>
				<h3>Media</h3>
				<Dropdown overlay={menu}>
					<Button type="link">
						Show {mediaPerPage} Elements <DownOutlined />
					</Button>
				</Dropdown>
				<Button type="primary" onClick={handleMediaUploadOpen}>
					<CloudUploadOutlined /> Upload Media
				</Button>
			</>
		);
		const footer = (
			<Button.Group>
				<Button
					icon={<LeftOutlined />}
					disabled={page === 0}
					onClick={handlePageChange(page - 1)}
				/>
				<Button
					icon={<RightOutlined />}
					disabled={media.length < 10}
					onClick={handlePageChange(page + 1)}
				/>
			</Button.Group>
		);
		return (
			<div className="mediaListWrapper">
				<RenderMediaItem
					header={showHeader ? header : null}
					showHeader={showHeader}
					footer={footer}
					media={media}
					event={event}
					listType={listType}
					linkType="eventMedia"
					handlePickItem={handlePickItem}
				/>
				<MediaUploadDialog
					open={mediaUploadDialogOpen}
					onCancel={handleMediaUploadOk}
					onOk={handleMediaUploadOk}
					client={client}
					event={event}
					refetch={refetch}
					media={media}
					multiple={true}
				/>
			</div>
		);
	}
}
